import React from 'react';
import Button from '@atlaskit/button/standard-button';
import { fg } from '@atlassian/jira-feature-gating';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';
import type { Props } from './types.tsx';

const TodayButton = ({ onClick, testId }: Props) => {
	const { formatMessage } = useIntl();
	return (
		<Button
			testId={testId}
			appearance="subtle"
			onClick={onClick}
			{...(fg('platform_button_item-add-ufo-metrics')
				? { interactionName: 'timeline-today-clicked' }
				: {})}
		>
			{formatMessage(messages.today)}
		</Button>
	);
};

export default TodayButton;
